import BaseRelationEditTemplate from './BaseRelation';

export default class SegmentsEdit extends BaseRelationEditTemplate {
  // eslint-disable-next-line class-methods-use-this
  get relationField() {
    return 'segments';
  }
}
